module.exports = __webpack_public_path__ + "static/media/blake21024676.95c3d748.png";